// Presentation only. These rows never replace a server confirmation or authorize progression.
export function minimumConfigurationKey (payload, user) {
  const copy = JSON.parse(JSON.stringify(payload))
  copy.items.forEach(item => item.colors.forEach(color => color.sizes.forEach(size => {
    delete size.quantity
    delete size.minimum_adjustment
  })))
  return JSON.stringify([copy, user])
}

export function provisionalMinimums (snapshot, payload) {
  if (!snapshot || !Array.isArray(snapshot.provisional_requirements)) return null
  const items = new Map(payload.items.map(item => [item.id, item]))
  const quantity = (item, reference, sizeId) => {
    const color = item && item.colors.find(color => color.reference === reference)
    const size = color && color.sizes.find(size => size.size_id === sizeId)
    return size ? Math.max(0, Number(size.quantity) || 0) : 0
  }
  const total = item => item ? item.colors.reduce((sum, color) => sum + color.sizes.reduce((n, size) => n + Math.max(0, Number(size.quantity) || 0), 0), 0) : 0
  const requirements = snapshot.provisional_requirements.map(template => {
    const row = JSON.parse(JSON.stringify(template))
    const item = items.get(row.style_line_id)
    let eligible = row.eligible_quantity
    if (row.type === 'style_minimum_quantity') eligible = quantity(item, row.color_reference, row.size_id)
    else if (row.type === 'sixes_quantity') {
      eligible = (row.quantity_targets || []).reduce((sum, target) => sum + quantity(item, target.color_reference, target.size_id), 0)
      row.required_quantity = Math.ceil(eligible / row.multiple) * row.multiple
      row.detail = 'Current color bucket: ' + eligible + ' pieces.'
    } else if (['technique_minimum', 'new_art_technique_minimum'].includes(row.type)) {
      eligible = row.contributors.reduce((sum, contributor) => sum + total(items.get(contributor.style_line_id)), 0)
    }
    if (row.type !== 'minimum_configuration' && eligible !== null) {
      row.eligible_quantity = eligible
      row.shortage = Math.max(0, row.required_quantity - eligible)
      row.blocking = !row.bypass_reason && eligible < (row.blocking_quantity == null ? row.required_quantity : row.blocking_quantity)
      if (row.type === 'style_minimum_quantity' && eligible === 0) { row.blocking = false; row.shortage = 0 }
      row.status = row.bypass_reason ? 'bypassed' : row.blocking ? 'needs_action' : 'met'
      row.action = row.blocking ? 'Adjust quantities, then Save to confirm requirements.' : ''
      row.adjustment_reason = ''
    }
    row.provisional = true
    return row
  })
  return { requirements }
}
